import { persistReducer, persistStore } from "redux-persist";
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import rootReducer from "../RootReducer";

const persistedReducer = persistReducer({ key: "Radwan_new", storage }, rootReducer);

const store = configureStore({ reducer: persistedReducer, middleware: [...getDefaultMiddleware({ serializableCheck: false })] });

const persister = persistStore(store);

export { store, persister };
